import {
  Typography,
} from '@mui/material';
import styled from 'styled-components';

import Link from '../../Link';

const ProfileButtonContainer = styled.div`
  margin-left: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.darkPrimary.dark};
`;

const ProfileButtonLink = styled(Link)`
  border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
  display: flex;
  cursor: pointer;
  position: absolute;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(1)};
  bottom: ${({ theme }) => theme.spacing(2)};
  width: 80%;
  &:hover {
    background: ${({ theme }) => theme.palette.backdrop.dark};
  }
`;

const NameText = styled(Typography)`
  && {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export { NameText, ProfileButtonContainer, ProfileButtonLink };
